import React from 'react';
import { Stack, Typography } from '@mui/material';
import { PendingDeliveryCards } from '../../components/commercial/PendingDeliveriesDialog';

/** Pedidos a entregar: al marcar entregado se guarda la fecha y se descuenta el stock. */
const MobileDeliveriesPage: React.FC = () => (
  <Stack spacing={2}>
    <Typography variant="body2" color="text.secondary">Pedidos cargados que todavía no entregaste.</Typography>
    <PendingDeliveryCards />
  </Stack>
);

export default MobileDeliveriesPage;
